<ng-container
  *ngIf="cs.vm$ | async as vm"
  [dgxGaContainer]="{
    eventCategory: 'appliance details form USA'
  }"
>
  <ng-container *ngIf="vm.displayFetchingQuoteLoadingOverlay; else form">
    <dgx-components-section-loading>
      <ng-template #sectionLoadingTemplate>
        <div class="appliance-details-stepped-form__section-loading p-6">
          <img
            alt="Processing Registration Logo"
            class="appliance-details-stepped-form__section-loading-image"
            src="assets/images/appliances-protected.svg"
          />
          <p
            class="appliance-details-stepped-form__section-loading-text px-6 pt-6"
          >
            {{
              'APPLIANCE_DETAILS_STEPPED_FORM_SUBMIT_FETCHING_QUOTE_LOADING_TEXT'
                | translate
            }}
          </p>
          <dgx-components-progress-bar
            [max]="100"
            [value]="vm.fetchingQuoteProgressValue"
            class="appliance-details-stepped-form__section-loading-progress-bar pt-8"
          />
        </div>
      </ng-template>
    </dgx-components-section-loading>
  </ng-container>

  <ng-template #form>
    <form
      *sharedSectionLoading="vm.form as form"
      (submitted)="onFormSubmit($event)"
      [dgxFormDisabled]="vm.registrationLoading"
      [dgxTestHook]="testHooks.Form"
      [formGroup]="form"
      class="appliance-details-stepped-form__form"
      dgxFormSubmit
      dgxGaFormSubmit
    >
      <ng-container *ngIf="vm.isPhotoRegJourney && vm.isCurrencyStep">
        <dgx-components-panel
          [rounded]="'md'"
          [spacing]="'sm'"
          [variant]="'promotion'"
          class="appliance-details-stepped-form__photo-reg-panel pb-5"
        >
          <h1 class="appliance-details-stepped-form__photo-reg-panel__title">
            {{
              'APPLIANCE_DETAILS_STEPPED_FORM_PHOTO_REG_PANEL_TITLE' | translate
            }}
          </h1>
          <p
            class="appliance-details-stepped-form__photo-reg-panel__subtitle py-3"
          >
            {{
              'APPLIANCE_DETAILS_STEPPED_FORM_PHOTO_REG_PANEL_SUBTITLE'
                | translate
            }}
          </p>
        </dgx-components-panel>
      </ng-container>

      <dgx-form-stepped-form
        (activeStep)="activeStep.emit($event)"
        [diplayProgressBarPadding]="true"
        class="appliance-details-stepped-form__stepped-form"
      >
        <dgx-form-stepped-form-field
          *ngIf="!vm.brandCode || (vm.brandCode && !vm.clientBrandCode)"
          [autoProgress]="true"
          [dgxFormField]="vm.cmsData.brandCodeField"
          [dgxTestHook]="testHooks.BrandCodeFilterList"
          [requiredHidden]="true"
          [trackFormField]="'option'"
          dgxGaFormField
          formControlName="brandCode"
        >
          <dgx-catalogue-brand-filter-list [sort]="brandSort.Popularity" />
        </dgx-form-stepped-form-field>

        <dgx-form-stepped-form-field
          [autoProgress]="true"
          [dgxFormDependantControl]="'brandCode'"
          [dgxFormField]="vm.cmsData.applianceCategoryCodeField"
          [dgxGaFormField]="{
            applianceCategory: vm.selectedBrandApplianceCategory
          }"
          [dgxTestHook]="testHooks.BrandApplianceCategorySelect"
          [loading]="vm.brandApplianceCategoriesLoading"
          [progressButtonsHidden]="true"
          [requiredHidden]="true"
          [trackFormField]="'option'"
          formControlName="applianceCategoryCode"
        >
          <dgx-catalogue-appliance-category-radio-list
            [brandCode]="vm.brandCode"
            [themeMode]="'branded-primary'"
          />
        </dgx-form-stepped-form-field>

        <dgx-form-stepped-form-field
          [autoProgress]="true"
          [dgxFormField]="vm.cmsData.applianceCodeField"
          [dgxGaFormField]="{
            applianceName: vm.selectedBrandApplianceName
          }"
          [dgxTestHook]="testHooks.BrandApplianceSelect"
          [loading]="vm.brandCategoryAppliancesLoading"
          [requiredHidden]="true"
          [trackFormField]="'option'"
          formControlName="applianceCode"
        >
          <dgx-catalogue-brand-category-appliance-radio-list
            [brandCode]="vm.brandCode"
            [categoryCode]="vm.applianceCategoryCode"
            [spacing]="'lg'"
            [themeMode]="'branded-primary'"
          />
        </dgx-form-stepped-form-field>

        <dgx-form-stepped-form-field
          *ngIf="
            !vm.cmsData.modelAndSerialNumberFieldset.modelNumberField
              .fieldHidden ||
            !vm.cmsData.modelAndSerialNumberFieldset.serialNumberField
              .fieldHidden
          "
          [dgxTestHook]="testHooks.ModelSerialNumberFieldset"
          [errorsHidden]="true"
          [progressButtonsHidden]="
            vm.showRegistrationScreen && vm.hasRegistrationCode
          "
          class="appliance-details-stepped-form__model-serial-number"
          formGroupName="modelAndSerialNumber"
        >
          <ng-container
            *ngIf="
              vm.showRegistrationScreen && vm.hasRegistrationCode;
              else modelSerialNumberFieldsetLabel
            "
          >
            <legend
              class="appliance-details-stepped-form__registration-code-label"
            >
              {{
                'APPLIANCE_DETAILS_STEPPED_FORM_REGISTRATION_CODE_FIELD_LABEL'
                  | translate
              }}
            </legend>

            <dgx-components-rich-text
              [content]="vm.cmsData.registrationCodeField.fieldHint"
              class="pb-5"
            />
          </ng-container>
          <ng-template #modelSerialNumberFieldsetLabel>
            <legend
              class="appliance-details-stepped-form__model-serial-number-label"
            >
              {{
                (vm.serializationCodeResponse
                  ? 'APPLIANCE_DETAILS_STEPPED_FORM_SERIALIZATION_RESPONSE_SUCCESS'
                  : 'APPLIANCE_DETAILS_STEPPED_FORM_MODEL_SERIAL_NUMBER_FIELD_LABEL'
                ) | translate
              }}
            </legend>

            <p class="pb-5">
              {{ vm.modelSerialNumberFieldsetDescription }}
            </p>
          </ng-template>

          <ng-container
            *ngIf="
              vm.showRegistrationScreen && vm.hasRegistrationCode;
              else modelSerialNumberFieldset
            "
          >
            <dgx-components-card
              *sharedSectionLoading="vm.loadingSubmitRegistrationCode"
              [dropShadow]="false"
              [theme]="'background-alternative'"
              class="mb-6"
            >
              <form
                *sharedSectionLoading="
                  vm.registrationCodeForm as registrationCodeForm
                "
                (submitted)="onRegistrationCodeFormSubmit($event)"
                [formGroup]="registrationCodeForm"
                dgxFormSubmit
              >
                <dgx-form-row>
                  <dgx-form-field
                    [requiredHidden]="true"
                    [trackFormField]="'option'"
                    dgxGaFormField
                    formControlName="registrationCode"
                  >
                    <dgx-form-label [requiredHidden]="true">
                      {{ vm.cmsData.registrationCodeField.fieldLabel }}
                    </dgx-form-label>

                    <dgx-form-text-input
                      [placeholder]="
                        vm.cmsData.registrationCodeField.fieldPlaceholder
                      "
                    />
                  </dgx-form-field>
                </dgx-form-row>
                <div class="registration-code__actions mt-6">
                  <dgx-form-submit-button [variant]="'primary'">
                    {{
                      'APPLIANCE_DETAILS_STEPPED_FORM_REGISTRATION_CODE_SUBMIT'
                        | translate
                    }}
                  </dgx-form-submit-button>

                  <a
                    *ngIf="vm.showRegistrationScreen"
                    (click)="toggleHasRegistrationCode(false)"
                    [dgxGaClick]="{
                      eventCategory: 'linkClicks',
                      eventAction: 'linkClicked',
                      eventLabel:
                        (vm.hasRegistrationCode
                          ? 'APPLIANCE_DETAILS_STEPPED_FORM_I_HAVE_NO_REGISTRATION_CODE'
                          : 'APPLIANCE_DETAILS_STEPPED_FORM_I_HAVE_A_REGISTRATION_CODE'
                        ) | translate,
                      applianceName: vm.selectedBrandApplianceName,
                      brand: vm.brand?.brandName
                    }"
                    class="appliance-details-stepped-form__registration-code-toggle"
                    >{{
                      (vm.hasRegistrationCode
                        ? 'APPLIANCE_DETAILS_STEPPED_FORM_I_HAVE_NO_REGISTRATION_CODE'
                        : 'APPLIANCE_DETAILS_STEPPED_FORM_I_HAVE_A_REGISTRATION_CODE'
                      ) | translate
                    }}
                  </a>
                </div>
              </form>
            </dgx-components-card>
          </ng-container>

          <ng-template #modelSerialNumberFieldset>
            <dgx-components-card
              [dropShadow]="false"
              [theme]="'background-alternative'"
              class="mb-3 appliance-details-stepped-form__model-serial-number"
            >
              <ng-container
                *ngIf="vm.serializationCodeResponse && !vm.navigatedToPriceStep"
              >
                <us-registration-appliance-details-stepped-form-registration-code-confirmation-panel
                  [appliance]="vm.serializationCodeResponse.Type"
                  [brandName]="vm.serializationCodeResponse.Brand"
                  [icon]="vm.serializationCodeResponse.icon"
                  class="mb-3"
                />
              </ng-container>

              <dgx-form-row>
                <dgx-form-field
                  *ngIf="
                    !vm.cmsData.modelAndSerialNumberFieldset.modelNumberField
                      .fieldHidden && vm.modelNumberSearchEnabled
                  "
                  [dgxFormField]="
                    vm.cmsData.modelAndSerialNumberFieldset.modelNumberField
                  "
                  [dgxTestHook]="testHooks.ModelNumberSelectTypeAhead"
                  [requiredHidden]="true"
                  [trackFormField]="'option'"
                  dgxGaFormField
                  formControlName="modelNumber"
                >
                  <dgx-catalogue-model-number-select-typeahead
                    [applianceCode]="vm.applianceCode"
                    [brandCode]="vm.brandCode"
                    [dgxTestHook]="testHooks.ModelNumberSelectTypeAhead"
                  />
                  <us-registration-appliance-details-stepped-content-toggle
                    *ngIf="vm.modelNumberFinderContent"
                    [dgxGaClick]="{
                      eventCategory: 'linkClicks',
                      eventLabel: 'Help me find my model and serial number',
                      eventAction: 'linkClicked',
                      applianceName: vm.selectedBrandApplianceName,
                      brand: vm.brand?.brandName
                    }"
                    [textBefore]="'Help me find my'"
                    [toggleLabel]="'model and serial number'"
                  >
                    <us-registration-appliance-details-stepped-form-find-model-serial-panel
                      [appliance]="vm.brandAppliance?.applianceName"
                      [modelNumberFinderContent]="vm.modelNumberFinderContent"
                    />
                  </us-registration-appliance-details-stepped-content-toggle>
                </dgx-form-field>
              </dgx-form-row>

              <dgx-form-row>
                <dgx-form-field
                  *ngIf="
                    !vm.cmsData.modelAndSerialNumberFieldset.modelNumberField
                      .fieldHidden && !vm.modelNumberSearchEnabled
                  "
                  [dgxFormField]="
                    vm.cmsData.modelAndSerialNumberFieldset.modelNumberField
                  "
                  [dgxTestHook]="testHooks.ModelNumberTextInput"
                  [requiredHidden]="true"
                  class="appliance-details-stepped-form__model-serial-number"
                  dgxGaFormField
                  formControlName="modelNumber"
                >
                  <dgx-form-text-input />
                  <us-registration-appliance-details-stepped-content-toggle
                    *ngIf="vm.modelNumberFinderContent"
                    [dgxGaClick]="{
                      eventCategory: 'linkClicks',
                      eventLabel: 'Help me find my model and serial number',
                      eventAction: 'linkClicked',
                      applianceName: vm.selectedBrandApplianceName,
                      brand: vm.brand?.brandName
                    }"
                    [textBefore]="'Help me find my'"
                    [toggleLabel]="'model and serial number'"
                  >
                    <us-registration-appliance-details-stepped-form-find-model-serial-panel
                      [modelNumberFinderContent]="vm.modelNumberFinderContent"
                    />
                  </us-registration-appliance-details-stepped-content-toggle>
                </dgx-form-field>
              </dgx-form-row>

              <dgx-form-row>
                <dgx-form-field
                  *ngIf="
                    !vm.cmsData.modelAndSerialNumberFieldset.serialNumberField
                      .fieldHidden
                  "
                  [dgxFormField]="
                    vm.cmsData.modelAndSerialNumberFieldset.serialNumberField
                  "
                  [dgxTestHook]="testHooks.SerialNumberTextInput"
                  [requiredHidden]="true"
                  dgxGaFormField
                  formControlName="serialNumber"
                >
                  <dgx-form-text-input />
                </dgx-form-field>
              </dgx-form-row>

              <a
                *ngIf="vm.showRegistrationScreen"
                (click)="toggleHasRegistrationCode(true)"
                [dgxGaClick]="{
                  eventCategory: 'linkClicks',
                  eventAction: 'linkClicked',
                  eventLabel:
                    (vm.hasRegistrationCode
                      ? 'APPLIANCE_DETAILS_STEPPED_FORM_I_HAVE_NO_REGISTRATION_CODE'
                      : 'APPLIANCE_DETAILS_STEPPED_FORM_I_HAVE_A_REGISTRATION_CODE'
                    ) | translate,
                  applianceName: vm.selectedBrandApplianceName,
                  brand: vm.brand?.brandName
                }"
                class="link"
                >{{
                  (vm.hasRegistrationCode
                    ? 'APPLIANCE_DETAILS_STEPPED_FORM_I_HAVE_NO_REGISTRATION_CODE'
                    : 'APPLIANCE_DETAILS_STEPPED_FORM_I_HAVE_A_REGISTRATION_CODE'
                  ) | translate
                }}</a
              >
            </dgx-components-card>

            <a
              (click)="toggleHasModelSerialNumber()"
              [dgxGaClick]="{
                eventCategory: 'linkClicks',
                eventLabel: 'I don\'t have my model or serial number',
                eventAction: 'linkClicked',
                applianceName: vm.selectedBrandApplianceName,
                brand: vm.brand?.brandName
              }"
              class="link p-6"
            >
              {{
                'APPLIANCE_DETAILS_STEPPED_FORM_I_DONT_HAVE_MODEL_OR_SERIAL_NUMBER'
                  | translate
              }}
            </a>

            <dgx-components-panel
              *ngIf="!hasModelSerialNumber"
              [border]="true"
              [rounded]="'md'"
              [spacing]="'sm'"
              [variant]="'error-alternative'"
              class="mt-4"
            >
              <div
                class="appliance-details-stepped-form__no-model-serial-warning"
              >
                <dgx-components-icon [icon]="'info-circle'" [size]="'sm'" />
                <p class="ml-3">
                  {{
                    'APPLIANCE_DETAILS_STEPPED_FORM_NO_MODEL_SERIAL_NUMBER_TELEPHONE_PREFIX'
                      | translate
                  }}
                  <a class="link" href="tel:+18335522314"
                    >{{
                      'APPLIANCE_DETAILS_STEPPED_FORM_NO_MODEL_SERIAL_NUMBER_TELEPHONE'
                        | translate
                          : {
                              telephoneNumber: '+1 833-552-2314'
                            }
                    }}
                  </a>
                  {{
                    'APPLIANCE_DETAILS_STEPPED_FORM_NO_MODEL_SERIAL_NUMBER_TELEPHONE_SUFFIX'
                      | translate
                  }}
                </p>
              </div>
            </dgx-components-panel>
          </ng-template>

          <ng-container
            *ngIf="vm.showRegistrationScreen && vm.hasRegistrationCode"
          >
            <p class="typog-body-bold text--center">
              {{
                'APPLIANCE_DETAILS_STEPPED_FORM_WHERE_TO_FIND_REGISTRATION_CODE'
                  | translate
              }}
            </p>
            <dgx-components-picture
              [alt]="'find-my-registration-code-helper'"
              [aspectRatio]="vm.isDesktop ? '2:1' : '0.77'"
              [src]="
                vm.isDesktop
                  ? 'assets/images/find-my-registration-code-helper-desktop.png'
                  : 'assets/images/find-my-registration-code-helper.png'
              "
            />
          </ng-container>
        </dgx-form-stepped-form-field>

        <dgx-form-stepped-form-field
          [dgxFormDependantControl]="'registrationCodeOrModelAndSerialNumber'"
          [dgxFormField]="vm.cmsData.purchasePriceField"
          [label]="vm.cmsData.purchasePriceField.fieldLabel"
          [requiredHidden]="true"
          [trackFormField]="'option'"
          class="appliance-details-stepped-form__purchase-price"
          dgxGaFormField
          formControlName="purchasePrice"
        >
          <dgx-form-currency-input />

          <ng-container
            *ngIf="
              vm.displayRegistrationCodeConfirmationPanel &&
              vm.serializationCodeResponse
            "
          >
            <p class="my-5">
              {{
                'APPLIANCE_DETAILS_STEPPED_FORM_PURCHASE_PRICE_SUMMARY_PANEL_TITLE'
                  | translate
              }}
            </p>

            <us-registration-appliance-details-stepped-form-registration-code-confirmation-panel
              [appliance]="vm.serializationCodeResponse.Type"
              [brandName]="vm.serializationCodeResponse.Brand"
              [icon]="vm.serializationCodeResponse.icon"
              class="appliance-details-stepped-form__registration-code-confirmation-panel"
            />
          </ng-container>
        </dgx-form-stepped-form-field>

        <dgx-form-stepped-form-field
          [dgxFormField]="vm.cmsData.purchaseDateField"
          [dgxTestHook]="testHooks.CalendarDatePicker"
          [label]="vm.cmsData.purchaseDateField.fieldLabel"
          [requiredHidden]="true"
          class="appliance-details-stepped-form__purchase-date"
          dgxGaFormField
          formControlName="purchaseDate"
        >
          <dgx-form-calendar-input [minimumDate]="vm.applianceMaximumAge" />
        </dgx-form-stepped-form-field>

        <dgx-form-stepped-form-field
          [errorsHidden]="true"
          formGroupName="personalDetails"
        >
          <dgx-form-legend
            class="appliance-details-stepped_personal-details-legend"
          >
            {{ vm.cmsData.personalDetailsFieldSet.fieldsetLegend }}
          </dgx-form-legend>

          <p class="appliance-details-stepped_required-field mb-6">
            {{ 'APPLIANCE_DETAILS_STEPPED_FORM_REQUIRED_FIELD' | translate }}
          </p>

          <dgx-form-row>
            <dgx-form-field
              [dgxFormField]="vm.cmsData.personalDetailsFieldSet.firstNameField"
              [dgxTestHook]="testHooks.FirstName"
              [trackFormField]="'status'"
              dgxGaFormField
              formControlName="firstName"
            >
              <dgx-form-text-input [dgxQmSanitise]="'block'" />
            </dgx-form-field>
          </dgx-form-row>

          <dgx-form-row>
            <dgx-form-field
              [dgxFormField]="vm.cmsData.personalDetailsFieldSet.lastNameField"
              [dgxTestHook]="testHooks.LastName"
              [trackFormField]="'status'"
              dgxGaFormField
              formControlName="lastName"
            >
              <dgx-form-text-input [dgxQmSanitise]="'block'" />
            </dgx-form-field>
          </dgx-form-row>

          <dgx-form-fieldset>
            <dgx-form-row>
              <dgx-form-label
                [optionalHidden]="true"
                class="appliance-details-stepped__address-label pb-3"
              >
                {{ 'PERSONAL_DETAILS_FORM_ADDRESS_LABEL' | translate }}
              </dgx-form-label>

              <dgx-form-override-address
                [addressOverrideCheckboxLabel]="
                  vm.cmsData.personalDetailsFieldSet.addressFieldset
                    .addressOverrideCheckboxLabel
                "
                [addressOverrideText]="
                  vm.cmsData.personalDetailsFieldSet.addressFieldset
                    .addressOverrideText
                "
                [dgxTestHook]="testHooks.OverrideAddressSelectTypeAhead"
                class="ph-no-capture"
                formGroupName="address"
              />
            </dgx-form-row>
          </dgx-form-fieldset>

          <dgx-form-row>
            <dgx-form-field
              [dgxFormField]="
                vm.cmsData.personalDetailsFieldSet.emailAddressField
              "
              [optionalHidden]="true"
              [trackFormField]="'status'"
              dgxGaFormField
              formControlName="emailAddress"
            >
              <dgx-form-email-input [dgxQmSanitise]="'block'" />
            </dgx-form-field>
          </dgx-form-row>

          <dgx-form-row>
            <dgx-form-field
              [dgxFormField]="
                vm.cmsData.personalDetailsFieldSet.telephoneNumberField
              "
              [optionalHidden]="true"
              [trackFormField]="'status'"
              dgxGaFormField
              formControlName="telephoneNumber"
            >
              <dgx-form-telephone-input [dgxQmSanitise]="'block'" />
            </dgx-form-field>
          </dgx-form-row>

          <dgx-form-row
            class="appliance-details-stepped__personal-details-privacy-policy mt-6"
          >
            <dgx-form-field
              [dgxFormField]="
                vm.cmsData.personalDetailsFieldSet.privacyPolicyField
              "
              dgxGaFormField
              formControlName="privacyPolicy"
            >
              <dgx-form-checkbox />
            </dgx-form-field>
          </dgx-form-row>
        </dgx-form-stepped-form-field>
      </dgx-form-stepped-form>
    </form>
  </ng-template>
</ng-container>
